module.exports = __webpack_public_path__ + "static/media/whatsapp-business.6d94cf49.svg";